export default quotationMiddleware

/** @ngInject */
function quotationMiddleware($state) {
    const ALLOWED_VIEW_STATE = [
        'state-form-initial',
        'state-form-landscape',
        'state-form-consumption',
        'state-result',
        'state-result-error',
        'state-timetable',
        'state-pot',
        'state-visitor',
    ]

    return (store) => (next) => (action) => {
        const previousState = store.getState()
        next(action)
        const nextState = store.getState()

        // On initialization, check if $state.current is defined, otherwise do nothing
        if ($state.current) {
            const isNotInitViewStateAction = action.type !== 'INIT_VIEW_STATE'
            const isCurrentStateQuotation = $state.current.name === 'quotation'
            const isViewStateDirty = previousState.quotation.viewState !== nextState.quotation.viewState
            const isAllowedViewState = ALLOWED_VIEW_STATE.indexOf(nextState.quotation.viewState) > -1
            if (isNotInitViewStateAction && isCurrentStateQuotation && isViewStateDirty && isAllowedViewState) {
                $state.go('quotation', { viewState: nextState.quotation.viewState }, { notify: false, location: true })
            }
        }

        return nextState
    }
}



// WEBPACK FOOTER //
// ./src/states/quotation/quotationMiddleware.service.js